<template>
  <div class="d-book-activity-feed panel panel-overflow background-grey">
    <div
      v-if="isInitialized && isEmpty"
      class="panel background-grey text-center padding-top-8em padding-bottom-5em"
    >
      <img
        alt="No activity yet"
        class="space-bottom-3em"
        :src="emptyImageSrc"
      >
      <h2>
        No updates yet.
      </h2>
      <p class="large">
        Come back later to check for updates.
      </p>
    </div>

    <div v-if="isInitialized && !isEmpty">
      <DActivityEntry
        v-for="activity in activities"
        :key="activity.slug"
        :activity="activity"
        :link-to-activity="true"
        :is-self="isSelf"
        :user-avatar-url="userAvatarUrl"
        :user-name="userName"
        @activity-removed="activityRemoved"
      />
    </div>

    <DuiLoadingIndicator
      v-if="isLoading"
      size="lg"
    />

    <div
      id="load-more-activities"
      class="load-more-activities"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import SATELLITE_IMG from '@d-assets/satellite.svg';
import DActivityEntry from '@d-components/d-activity-feed/d-activity-entry/d-activity-entry.vue';
import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import { whenElementIsVisible } from '@dui/helpers/util-funcs';

export default {
  components: {
    DActivityEntry,
  },
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
    isSelf: {
      type: Boolean,
      default: false,
    },
    userAvatarUrl: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    activities: [],
    disableLoadMore: null,
    emptyImageSrc: SATELLITE_IMG,
    isEmpty: false,
    isInitialized: false,
    isLoading: false,
    paginationInfo: {
      hasMoreResults: false,
      pageNum: 0,
    },
  }),
  beforeDestroy() {
    if (this.disableLoadMore) {
      this.disableLoadMore();
    }
  },
  mounted() {
    this.loadBookFeed();
  },
  methods: {
    activityRemoved(removedActivity) {
      const activityIdx = this.activities.findIndex(a => a.slug === removedActivity.slug);
      if (activityIdx === -1) {
        return;
      }

      this.activities.splice(activityIdx, 1);
    },

    enableLoadMore() {
      if (this.disableLoadMore) {
        this.disableLoadMore();
      }

      const disableLoadMore = whenElementIsVisible('#load-more-activities', this.loadBookFeed.bind(this));
      this.$set(this, 'disableLoadMore', disableLoadMore);
    },

    async loadBookFeed() {
      this.$set(this, 'isLoading', true);

      try {
        this.paginationInfo.pageNum++;

        const feed = await activityFeedService.getBookActivities(this.bookSlug, this.paginationInfo.pageNum);
        this.$set(this, 'activities', this.activities.concat(feed.activities));
        this.$set(this.paginationInfo, 'hasMoreResults', !!feed.meta.next_page);

        if (this.paginationInfo.hasMoreResults) {
          this.enableLoadMore();
        }

        if (!this.isInitialized) {
          this.$set(this, 'isInitialized', true);
          if (!feed.activities.length) {
            this.$set(this, 'isEmpty', true);
          }
        }
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isLoading', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-activity-feed {
  overflow: visible;
  padding-bottom: $_2em !important;
  padding-top: $_2em !important;

  > .dui-loading-indicator {
    padding: $_4em 0;
    text-align: center;
    width: 100%;
  }
}
</style>
